<template>
  <v-form ref="form">
    <v-select
      id="axis-select"
      v-model="filter.categorias"
      item-text="categoriaInstituicaoNome"
      item-value="categoriaInstituicaoId"
      :items="categorias"
      :label="name || 'Categoria'"
      :placeholder="name || 'Categoria'"
      multiple
      :rules="rules"
    >
      <div
        style="display: flex; padding: 0 10px; cursor: pointer"
        slot="prepend-item"
        ripple
        @click="toggle"
      >
        <div style="margin-right: 32px">
          <v-icon
            :color="filter.categorias.length > 0 ? 'indigo darken-4' : ''"
            >{{ icon }}</v-icon
          >
        </div>
        <div>Todos</div>
      </div>
      <v-divider slot="prepend-item" class="mt-2" />

      <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay"
          >{{ item.categoriaInstituicaoNome }} &nbsp;</span
        >
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ filter.categorias.length - maxDisplay }} categorias)</span
        >
      </template>

      <template slot="no-data"> Nenhuma Categoria retornada </template>
    </v-select>
  </v-form>
</template>

<script>
import { categoriaAPI } from "../API/categoriaAPI";

export default {
  name: "CategoriaCombobox",
  props: ["filter", "name", "rules"],
  mounted() {
    this.loadAxis();
  },
  methods: {
    loadAxis() {
      categoriaAPI
        .list()
        .then((resp) => {
          this.categorias = resp.data;
        })
        .catch();
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.categorias = [];
        } else {
          this.filter.categorias = this.categorias.slice();
        }
      });
    },
  },
  computed: {
    likesAll() {
      return this.filter.categorias.length === this.categorias.length;
    },
    likesSome() {
      return this.filter.categorias.length > 0 && !this.categorias;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 1,
      categorias: [],
    };
  },
};
</script>
